import { REGEX } from 'src/constants';
import { getTranslation } from 'src/utilities/translator';
import * as yup from 'yup';
import { isEmailNotContainsPhoneNumber } from '../string';

// TODO: Add error messages for all REGEX based validation
export const globalSchema = {
  ACCOUNT_NUMBER: yup.string().required().matches(REGEX.ACCOUNT_NUMBER),
  FULL_NAME: yup.string().required().max(64),
  EMAIL: yup
    .string()
    .required()
    .email()
    .test(
      'is-email',
      getTranslation('formError_wrongEmailFormat'),
      isEmailNotContainsPhoneNumber,
    )
    .max(256),
  PHONE_NUMBER: yup
    .string()
    .required()
    .matches(REGEX.PHONE_NUMBER, getTranslation('formError_wrongPhoneFormat'))
    .nullable()
    .transform(value => value || null),
  PASSWORD: yup
    .string()
    .required()
    .min(8)
    .max(256)
    .matches(
      REGEX.PASSWORD,
      getTranslation('passwordField_passwordNotMatchMessage'),
    ),
  NEW_PASSWORD: yup
    .string()
    .required()
    .min(8)
    .max(256)
    .matches(
      REGEX.PASSWORD,
      getTranslation('passwordField_passwordNotMatchMessage'),
    )
    .notOneOf([yup.ref('password')]),
  NEW_PASSWORD_CONFIRMATION: yup
    .string()
    .required()
    .oneOf(
      [yup.ref('new_password'), ''],
      getTranslation('formError_passwordDoesNotMatch'),
    ),
  USERNAME: yup.string().required().min(6).matches(REGEX.NAME),
  BRAND_NAME: yup
    .string()
    .required()
    .max(128)
    .notOneOf(['tokoku', 'pulsamarket', 'galaxyyshop101'])
    .matches(REGEX.NAME),
  COMPANY_NAME: yup.string().max(256).matches(REGEX.COMPANY_NAME),
  INDUSTRY: yup.string().required().max(128),
  ADDRESS: yup.string().max(128),
  PIC_NAME: yup.string().max(64),
  PIC_EMAIL: yup
    .string()
    .email()
    .test(
      'is-email',
      getTranslation('formError_wrongEmailFormat'),
      isEmailNotContainsPhoneNumber,
    )
    .max(256),
  DATE_OF_INCORPORATION: yup.string().required(),
  NPWP_NUMBER: yup.string().required(),
  REFERRAL_CODE: yup.string().max(64),
  KTP_NUMBER: yup.string().required().matches(REGEX.KTP_NUMBER),
  POSTAL_CODE: yup.string().required().matches(REGEX.POSTAL_CODE),
  BIRTH_PLACE_AND_DATE: yup
    .string()
    .required()
    .matches(REGEX.BIRTH_PLACE_AND_DATE),
  BUSINESS_LINK: yup.string().required().matches(REGEX.BUSINESS_LINK),
};
